module.exports = __webpack_public_path__ + "assets/img/jindong_2.122b6fc0.png";